module.exports = __webpack_public_path__ + "img/title-page-img.cc9237a1.png";